export default __webpack_public_path__ + "static/media/H'Wear Side Right.655954ab.jpg";